import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import TextBlock from '../../components/textBlock'
import { translate } from '../../helpers/stringHelpers'

export const ErrorNotFound = (props) => (
  <div>
    <h1>{translate('JspPublicCodes_ERROR_NOT_FOUND_TITLE')}</h1>
    <TextBlock>{translate('JspPublicCodes_ERROR_NOT_FOUND_DESCRIPTION')}</TextBlock>
    <Link to={props.returnPath}>&laquo; {translate('JSTextCodes_BACK')}</Link>
  </div>
)

ErrorNotFound.propTypes = {
  returnPath: PropTypes.string.isRequired
}

ErrorNotFound.defaultProps = {
  returnPath: '/'
}

export default ErrorNotFound
